import { render } from "./PartnerNoticeView.vue?vue&type=template&id=7a887ae5"
import script from "./PartnerNoticeView.vue?vue&type=script&lang=js"
export * from "./PartnerNoticeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__